import React from "react";
import styled from "styled-components";
import polarian from "../../../assets/images/solutions/polarian.png";

const PolarianALMSolutionOverview = () => {
  return (
    <AboutSectionWrapper>
      <Container className="container">
        <Row>
          {/* Content Column */}
          <ContentColumn>
            <InnerColumn>
              <SecTitle>
                <Title>About Us</Title>
                <Heading>Overview</Heading>
              </SecTitle>
              <Text>
                NextechPLM is your strategic partner in digital innovation, delivering cutting-edge solutions powered by Polarion ALM – Siemens’ advanced, cloud-based Application Lifecycle Management platform.
Polarion ALM unifies requirements management, test management, agile development, and compliance tracking into a single, collaborative platform — accelerating product development and ensuring traceability from concept to release.
At NextechPLM, we specialize in full-spectrum Polarion ALM services — from implementation and customization to managed support — helping teams streamline workflows, boost productivity, and achieve compliance effortlessly across software and hardware domains.
Unlock the Power of Polarion ALM with NextechPLM – Deliver Better Products, Faster, Smarter, and With Confidence.

              </Text>
            </InnerColumn>
          </ContentColumn>
          {/* Image Column */}
          <ImageColumn>
            <ImageInnerColumn data-wow-delay="0ms" data-wow-duration="1500ms">
              <ImageWrapper>
                <Image
                  src={polarian}
                  alt="Polarian ALM Solution"
                />
                <ImageOverlayBox></ImageOverlayBox>
              </ImageWrapper>
            </ImageInnerColumn>
          </ImageColumn>
        </Row>
      </Container>
    </AboutSectionWrapper>
  );
};

export default PolarianALMSolutionOverview;

const AboutSectionWrapper = styled.section`
  font-family: "Poppins", system-ui;
  position: relative;
  padding: 20px 0px;
`;

const Container = styled.div`
  .container;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContentColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 10px;
  @media (max-width: 992px) {
    padding-right: 0;
  }
`;

const InnerColumn = styled.div`
  position: relative;
  padding-top: 50px;
`;

const SecTitle = styled.div`
  position: relative;
  padding-bottom: 40px;
`;

const Title = styled.div`
  position: relative;
  color: #d7a449;
  font-size: 18px;
  font-weight: 700;
  padding-right: 50px;
  margin-bottom: 15px;
  display: inline-block;
  text-transform: capitalize;

  &:before {
    position: absolute;
    content: "";
    right: 0px;
    bottom: 7px;
    width: 40px;
    height: 1px;
    background-color: #bbbbbb;
  }
`;

const Heading = styled.h2`
  color: #252525;
`;

const Text = styled.div`
  position: relative;
  color: #777777;
  font-size: 1em;
  line-height: 2em;
  margin-bottom: 40px;
  text-align: justify;
`;

const ImageColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 50px;
`;

const ImageInnerColumn = styled.div`
  position: relative;
  padding: 40px 40px 0px 0px;
  margin-left: 50px;

  &:after {
    position: absolute;
    content: "";
    right: 27px;
    top: 5px;
    left: 40px;
    bottom: 64px;
    z-index: -1;
    border: 2px solid #d7a449;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageOverlayBox = styled.div`
  position: absolute;
  left: 40px;
  bottom: 48px;
`;

const Image = styled.img`
  position: relative;
  width: 90%; /* Adjust the width as needed */
  display: block;
  margin: 0 auto; /* Center the image */
`;
